import upload from './actions/upload'

export default {
  upload
}
